import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/** Stack-light / Andon icon (three segments). */
const SignalsIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M10 2h4v1.5h-4z" />
    <rect x="8" y="3.5" width="8" height="4.2" rx="1.2" fill="currentColor" opacity="0.95" />
    <rect x="8" y="8.2" width="8" height="4.2" rx="1.2" fill="currentColor" opacity="0.75" />
    <rect x="8" y="12.9" width="8" height="4.2" rx="1.2" fill="currentColor" opacity="0.55" />
    <path d="M9.5 17.5h5v1.2h-5z" />
    <path d="M11 18.7h2v3.3h-2z" />
  </SvgIcon>
);

export default SignalsIcon;
